<template>
  <div>
    <footer class="footer">
      <div class="container">
        <div class="content has-text-centered">
          <p>
            <a href="https://bulma.io">
              <img 
                src="https://bulma.io/images/made-with-bulma.png" 
                alt="Made with Bulma" 
                width="128" 
                height="24">
            </a>
            <br>
            <strong>Vue Fluent Components
            </strong> by
            <a 
              href="http://mubaidr.github.com" 
              target="_blank"> Muhammad Ubaid Raza
            </a>
            <br> Icons from
            <a 
              href="http://fontawesome.io/" 
              target="_blank">Font Awesome
            </a>.
            <br> The source code is licensed under
            <a 
              href="http://opensource.org/licenses/mit-license.php" 
              target="_blank">MIT
            </a>.
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'FooterView',
}
</script>

<style>
</style>
